import { getConfig } from "@edx/frontend-platform";
import { getAuthenticatedHttpClient } from "@edx/frontend-platform/auth";

export const getAiCanvasConversationStarter = async (contextId, numberOfSuggestions = 3) => {
    let url = `${getConfig().LMS_BASE_URL}/blendxapi/ai/suggetions/canvas/`;
    const { data } = await getAuthenticatedHttpClient().post(url, {
        "context_id": contextId,
        "number_of_suggestions": numberOfSuggestions
    });
    return data;
};